import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './lang';
import LOG from './utils/log';
import '@/assets/style/reset.css';

Vue.config.productionTip = false;
Vue.config.devtools = true;

Vue.prototype.$LOG = LOG;
// 兼容ios的active
document.addEventListener('touchstart', function() {});

new Vue({
    router,
    store,
    i18n,
    render: h => h(App)
}).$mount('#app');
